<script setup lang="ts">
import { login } from '@/helpers/auth'
import { ref, type Ref } from 'vue'
import { setSession, useSession } from '@/helpers/globals'
import { useRouter } from 'vue-router'
import KpTextfield from '@/components/kp-textfield.vue'

const username = ref('')
const password = ref('')
const loading = ref(false)

const error: Ref<unknown> = ref()
const router = useRouter()

async function tryLogin() {
    try {
        loading.value = true
        const response = await login(username.value, password.value)
        if (response.user) {
            const csrfToken = useSession().csrfToken
            setSession({ benutzer: response.user, csrfToken })
        }
        if (response.redirectUrl) {
            router.push(response.redirectUrl)
        }
    } catch (e: unknown) {
        error.value = e
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" sm="9">
                    <v-form :loading="loading" autocomplete="on" @submit.prevent="tryLogin">
                        <v-card
                            class="trans-bg"
                            max-width="600px"
                            style="margin: auto; margin-top: 10rem; padding-left: 1rem"
                        >
                            <v-card-title>{{ $t('login') }}</v-card-title>
                            <v-card-text>
                                <KpTextfield
                                    v-model="username"
                                    :label="$t('email')"
                                    :placeholder="$t('zb') + ' name@domain.com'"
                                    icon-type="email"
                                    autocomplete="on"
                                    :autofocus="true"
                                    :disabled="loading"
                                />
                                <KpTextfield
                                    v-model="password"
                                    icon-type="password"
                                    :label="$t('pw')"
                                    :disabled="loading"
                                />
                                <router-link :to="{ name: 'reset' }">
                                    {{ $t('forgot_pw') }}
                                </router-link>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn to="/" :disabled="loading">{{ $t('cancel') }}</v-btn>
                                <v-btn
                                    variant="flat"
                                    color="action white--text"
                                    :loading="loading"
                                    :disabled="loading"
                                    type="submit"
                                    @click.prevent="tryLogin"
                                >
                                    {{ $t('absenden') }}
                                </v-btn>
                            </v-card-actions>

                            <v-fade-transition>
                                <v-card-text v-if="error">
                                    <v-alert type="error">{{ error }}</v-alert>
                                </v-card-text>
                            </v-fade-transition>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
